import React, { useState } from "react";
import { AiOutlinePlus, AiOutlineTag } from "react-icons/ai";
import { BsTrash } from "react-icons/bs";
import Confirm from "../../../../../components/confirm/Confirm";
import { LoadingIcon } from "../../../../../components/loading/Loading";
import ChannelTags from "../../../../../components/pickers/channel-tags/ChannelTags";
import useRouting, { Link } from "../../../../../contexts/Routing";
import {
    GetChatSettingsDocument,
    GetSlackChannelSettingsDocument, useDeleteChatSettingsMutation,
    useGetSlackChannelSettingsQuery,
} from "../../../../../__generated__/api";

export default function ChannelTagSettings() {
    const { data: chatSettings, loading: isChatLoading } = useGetSlackChannelSettingsQuery();

    const [deleteSettings] = useDeleteChatSettingsMutation();
    const [deletingTag, setDeletingTag] = useState<{id: string, name: string}>();
    const { Paths, historyPush } = useRouting();

    const onDelete = () => {
        (async () => {
            if (!deletingTag) {
                return;
            }
            await deleteSettings({
                refetchQueries: [
                    { query: GetSlackChannelSettingsDocument },
                    { query: GetChatSettingsDocument, variables: { id: deletingTag.id } },
                ],
                variables: {
                    id: deletingTag.id,
                },
            });
            setDeletingTag(undefined);
        })();
    };
    return (
        <div className="border p-3 rounded mb-4 bg-white">

            <Confirm
                confirmText="Delete"
                onConfirm={onDelete}
                shouldShow={deletingTag != null}
                onHide={() => setDeletingTag(undefined)}
            >
                <div>
                    Are you sure you want to delete any settings associated with
                    this tag? This will not delete the tag or its association to channels.
                    This will only delete any settings associated tag settings.
                    {" "}
                    <div className="mt-2 p-2 rounded alert alert-danger">
                        <AiOutlineTag className="me-1" />
                        {deletingTag?.name}
                    </div>
                    {" "}

                </div>
            </Confirm>
            <h5 className="mb-3 text-light">
                Channel Tag Settings
                {" "}
                <small><strong>(beta)</strong></small>
            </h5>

            <p className="text-light">
                Channel tag settings allow you to apply settings to a set of channels
                all sharing a given tag. For example, say you have a set of premium customer
                channels and you want all of them to have the same welcome message. You can create
                a channel tag called #premium-customers, add the #premium-customers tag to the
                required customers, and modify the channel tag settings below to customize the welcome
                message. This way if you need to change this welcome message, you can customize it
                in the section below instead of setting it for each individual channel.
            </p>

            {isChatLoading && <LoadingIcon />}
            <div className="list-group">
                {chatSettings?.channelTags?.map(tag => (
                    <div className={"flex-grow-1 list-group-item list-group-item-action d-flex justify-content-between "
                         + " align-items-center"}
                    >
                        <Link
                            key={tag.id}
                            to={Paths.ADMINISTRATOR_SETTING_ID}
                            params={{
                                setting: "chat",
                                id: tag.id,
                            }}
                            className="btn btn-none flex-grow-1 text-start py-1 px-0 m-0"
                        >

                            <h5 className="mb-0 ">
                                <AiOutlineTag className="me-2" />
                                {tag.options?.tag?.name}
                            </h5>

                        </Link>
                        <button
                            type="button"
                            className="btn btn-none p-0 m-0"
                            onClick={() => {
                                setDeletingTag({
                                    id: tag.id,
                                    name: tag.options?.tag?.name ?? "",
                                });
                            }}
                        >
                            <BsTrash className="text-light" />
                        </button>
                    </div>

                ))}

            </div>
            <div className="d-flex align-items-middle my-3">
                <ChannelTags
                    placeholder="Please pick a list of channel tags"
                    onSelected={selectedTag => {
                        historyPush(Paths.ADMINISTRATOR_SETTING_ID, {
                            setting: "chat",
                            id: `urn:fq:channel-tag:${selectedTag}`,
                        });
                    }}
                    value=""
                    className="btn btn-sm p-0 btn-none"
                    canCreate
                    shouldShowDropdown
                    toggleText={(
                        <span className="m-0 p-0">
                            <AiOutlinePlus />
                            {" "}
                            Add Channel Tag Settings
                        </span>
                    )}
                />

            </div>

        </div>
    );
}
